import { createContext, useContext } from "react";

import { UserRole } from "../utils/general";

export const RoleContext = createContext<UserRole | null>(null);

export const useRole = () => useContext(RoleContext);
